import { useCallback, useSyncExternalStore } from 'react';
import {
  DATA_SAVER_CHANGE_EVENT,
  dataSaverActive,
  setDataSaverPreference,
} from '../lib/data-saver';

/**
 * Hook baca/tulis mode hemat data (spec CP12). Subscript lewat event DOM
 * (state global minimum — code-standards.md: Query cache + context; preferensi
 * kecil ini cukup event + localStorage, tanpa store baru).
 */
export function useDataSaver(): {
  readonly active: boolean;
  readonly toggle: () => void;
} {
  const active = useSyncExternalStore(subscribe, getSnapshot, () => false);
  const toggle = useCallback(() => {
    setDataSaverPreference(!dataSaverActive());
  }, []);
  return { active, toggle };
}

function subscribe(onChange: () => void): () => void {
  globalThis.addEventListener(DATA_SAVER_CHANGE_EVENT, onChange);
  return () => globalThis.removeEventListener(DATA_SAVER_CHANGE_EVENT, onChange);
}

function getSnapshot(): boolean {
  return dataSaverActive();
}
